var map = {
	"./agoda.svg": 4183,
	"./airbnb.svg": 5813,
	"./aspects.svg": 2742,
	"./bad-reviews.svg": 5664,
	"./booking.svg": 596,
	"./categories.svg": 731,
	"./filters.svg": 7968,
	"./intro.svg": 6599,
	"./locations.svg": 6905,
	"./new-reviews.svg": 3583,
	"./open-reviews.svg": 4303,
	"./positive-reviews.svg": 4390,
	"./prices.svg": 3245,
	"./regions.svg": 42,
	"./timeline.svg": 4590,
	"./tripadvisor.svg": 8118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;